<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          title="ポイント設定詳細"
          icon="point"
          class="point-setting-header" />
      <BaseBackButton
          :is-show="showBackButton"
          :return-destination="'/pointSetting'" />
      <BaseDetailMoveData
          :id="detailData.id"
          :list-index="listIndex"
          :mode="mode"
          :array-lists="sortedList"
          :path-parameter="['id']"
          title="ID"
          router-path="/pointSetting/" />
    </el-row>
    <el-row>
      <el-col :span="13">
        <div class="edit-table-list">
          <div class="table-vertical">
            <div class="edit-button-wrap">
              <BaseButton v-show="showEditButton"
                  @click="edit()">
                編集
              </BaseButton>
              <BaseButton v-show="showCancelButton"
                  @click="cancel()">
                キャンセル
              </BaseButton>
              <BaseButton v-show="showSaveButton"
                  @click="save()">
                保存
              </BaseButton>
            </div>
            <BaseTableDetail
                :border="true"
                :table-set-list="detailDataSetList"
                :display-item="detailData"
                :editable="editable"
                class="pointsetting-detail-table" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'
import * as define from '@/define'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

const EDITABLE = Object.freeze({
  [define.MODE.NORMAL]: Object.freeze({}),
  [define.MODE.EDIT]: Object.freeze(
    { rate: true, point: true, target: true, limited: true, exp: true, expUnit: true,
      code: true, priority: true, add: true, between: true }),
  [define.MODE.NEW]: Object.freeze(
    { rate: true, point: true, target: true, limited: true, exp: true, expUnit: true,
      code: true, priority: true, add: true, between: true })
})

const returnDestination = '/pointSetting'

export default {
  name: 'PointSettingDetail',
  mixins: [x, confirmDiscardOnLeave],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      detailDataSetList: [
        {
          label: 'ID',
          properties: [
            { path: 'id', type: 'String' }
          ]
        }, {
          label: 'ポイント付与レート',
          properties: [
            { path: 'rate', type: 'Number', editableId: 'rate', elementType: ELEMENT_TYPE.INPUT_NUMBER, fractionDigits: 2 }
          ]
        }, {
          label: '付与ポイント',
          properties: [
            { path: 'point', type: 'Number', editableId: 'point', elementType: ELEMENT_TYPE.INPUT_NUMBER }
          ]
        }, {
          label: 'ポイント計算対象',
          properties: [
            { path: 'target', type: 'Number', editableId: 'target', selectCode: 'm_point_config.is_include_tax',
              elementType: ELEMENT_TYPE.RADIO_BUTTON },
            { path: 'targetList', type: 'String', editableId: 'target',
              elementType: ELEMENT_TYPE.INPUT_TEXT_AREA, rows: 2 }
          ]
        }, {
          label: '',
          properties: [
            { path: 'includeTax', type: 'String', editableId: 'target',
              elementType: ELEMENT_TYPE.CHECK_BOX, single: true, label: '消費税' },
            { path: 'includeNonProduct', type: 'String', editableId: 'target',
              elementType: ELEMENT_TYPE.CHECK_BOX, single: true, label: '商品外' },
            { path: 'includeSale', type: 'String', editableId: 'target',
              elementType: ELEMENT_TYPE.CHECK_BOX, single: true, label: 'セール品' },
            { path: 'includePreorder', type: 'String', editableId: 'target',
              elementType: ELEMENT_TYPE.CHECK_BOX, single: true, label: '予約品' }
          ],
          horizontal: true
        }, {
          label: '期間限定',
          properties: [
            { path: 'limited', type: 'String', editableId: 'limited', selectCode: 'm_point_config.is_limited',
              elementType: ELEMENT_TYPE.CHECK_BOX }
          ]
        }, {
          label: '有効期限',
          properties: [
            { path: 'exp', type: 'Number', editableId: 'exp', elementType: ELEMENT_TYPE.INPUT_NUMBER },
            { path: 'expUnit', type: 'String', editableId: 'expUnit',
              codeName: 'm_point_base_config.expires_unit', selectCode: 'm_point_config.expires_unit',
              elementType: ELEMENT_TYPE.SELECT_BOX }
          ],
          horizontal: true
        }, {
          label: 'プロモーションコード',
          properties: [
            { path: 'code', type: 'String', editableId: 'code', elementType: ELEMENT_TYPE.INPUT }
          ]
        }, {
          label: '優先順位',
          properties: [
            { path: 'priority', type: 'String', editableId: 'priority', elementType: ELEMENT_TYPE.INPUT }
          ]
        }, {
          label: '加算',
          properties: [
            { path: 'add', type: 'String', editableId: 'add', selectCode: 'm_point_config.is_addition',
              elementType: ELEMENT_TYPE.RADIO_BUTTON }
          ]
        }, {
          label: '適用期間',
          properties: [
            { path: 'between', type: 'Date', editableId: 'between', elementType: ELEMENT_TYPE.DATE_TIME_RANGE }
          ]
        }
      ],
      detailData: {},
      // sample データ
      getDataSample: [
        { id: 1,
          rate: 1,
          point: 100,
          target: 1,
          targetList: '',
          includeTax: 0,
          includeNonProduct: 0,
          includeSale: 0,
          includePreorder: 0,
          limited: [],
          exp: null,
          expUnit: null,
          code: 'FW Sale',
          priority: 1,
          add: 0,
          between: null
        },
        { id: 2,
          rate: 1,
          point: 100,
          target: 1,
          targetList: '',
          includeTax: 0,
          includeNonProduct: 0,
          includeSale: 0,
          includePreorder: 0,
          limited: [],
          exp: null,
          expUnit: null,
          code: 'FW Sale',
          priority: 1,
          add: 0,
          between: null
        },
        { id: 3,
          rate: 1,
          point: 100,
          target: 1,
          targetList: '',
          includeTax: 0,
          includeNonProduct: 0,
          includeSale: 0,
          includePreorder: 0,
          limited: [],
          exp: null,
          expUnit: null,
          code: 'FW Sale',
          priority: 1,
          add: 0,
          between: null
        }
      ],
      pointSettingDetail: {
        id: 1,
        rate: 1,
        point: 100,
        target: 1,
        targetList: '',
        includeTax: 0,
        includeNonProduct: 0,
        includeSale: 0,
        includePreorder: 0,
        limited: [],
        exp: null,
        expUnit: null,
        code: 'FW Sale',
        priority: 1,
        add: 0,
        between: null
      }
    }
  },
  computed: {
    defaultModel: () => {
      return {
        id: null, rate: 1.00, point: 1, target: null, targetList: null, targetFlag: null,
        limited: null, exp: null, expUnit: null, code: null, priority: null, add: null, between: null
      }
    },
    ...mapState({
      listIndex: (state) => state.PointSetting.listIndex,
      tableSetList: (state) => state.PointSetting.tableSetList,
      currentPage: (state) => state.PointSetting.currentPage,
      size: (state) => state.PointSetting.size,
      mode: (state) => state.PointSetting.mode,
      returnList: (state) => state.PointSetting.returnList
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    sortedList () {
      return this.$store.getters['sortedList']('PointSetting', this.sortCondition('pointSettingList'))
    },
    showBackButton () {
      return this.mode === define.MODE.NORMAL
    },
    showEditButton () {
      return this.mode === define.MODE.NORMAL
    },
    showSaveButton () {
      return this.mode !== define.MODE.NORMAL
    },
    showCancelButton () {
      return this.mode !== define.MODE.NORMAL
    },
    editable () {
      return EDITABLE[this.mode]
    }
  },
  created () {
    this.getDetailData()
    this.checkMode()
  },
  beforeRouteUpdate (to, from, next) {
    // ポイント設定詳細間移動時の処理.
    next()
    this.getDetailData()
  },
  methods: {
    checkMode () {
      if ([ define.MODE.EDIT, define.MODE.NEW ].includes(this.mode)) {
        this.$_ConfirmDiscardOnLeave_watchStart(this.detailData)
      }
    },
    edit () {
      this.setMode(define.MODE.EDIT)
      this.checkMode()
    },
    save () {
      this.$_ConfirmDiscardOnLeave_watchEnd()
      this.decideTransition()
    },
    cancel () {
      this.$_ConfirmDiscardOnLeave_watchEnd()
      this.decideTransition()
    },
    getDetailData () {
      this.$loadingService.show()
      const param = this.$route.params.id
      const g = () => {
        if (this.mode === define.MODE.NEW) {
          return this.defaultModel
        } else {
          // sampleData
          for (const item of this.getDataSample) {
            if (item.id === Number(param)) { return item }
          }
        }
      }
      this.detailData = g()
      this.$loadingService.close()
    },
    /**
     * 詳細画面への遷移方法を検知して、帰還する画面を決定します。
     */
    decideTransition: function () {
      if (this.returnList) {
        this.$store.dispatch({
          type: 'set',
          states: {
            'PointSetting/returnList': false
          }
        })
        this.$router.push({ path: returnDestination })
      }
      this.setMode(define.MODE.NORMAL)
    },
    setMode (mode) {
      this.$store.commit({
        type: 'set',
        states: {
          'PointSetting/mode': mode
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/point/PointSettingDetailTop.vue